import {
  extensionFunctionType,
  extensionWebhookType,
} from '@rossum/api-client/hooks';
import { Box } from '@rossum/ui/material';
import { FormattedMessage } from 'react-intl';
import {
  FUNCTIONS_LINK,
  WEBHOOKS_LINK,
} from '../../../../../../constants/values';
import { link } from '../../../../../../lib/formaterValues';
import { CreatableHookType,extensionTypeConfig } from '../helperConfig';
import styles from '../style.module.sass';

type Props = {
  extensionType: CreatableHookType;
  onClick: () => void;
  selected: boolean;
  dataCy?: string;
};

export const ExtensionTypeSelect = ({
  extensionType,
  onClick,
  selected,
  dataCy,
}: Props) => {
  return (
    <Box
      sx={{
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        backgroundColor: t => (selected ? t.palette.action.hover : undefined),
        border: t =>
          selected
            ? `2px solid ${t.palette.primary.main}`
            : `1px solid ${t.palette.action.hover}`,
        '&:hover': {
          border: t =>
            selected
              ? `2px solid ${t.palette.primary.main}`
              : `1px solid ${t.palette.action.active}`,
        },
      }}
      className={styles.ExtensionType}
      onClick={onClick}
      data-cy={dataCy}
    >
      <div className={styles.ExtensionTypeLabel}>
        {extensionTypeConfig[extensionType].icon}
        <FormattedMessage id={extensionTypeConfig[extensionType].translation} />
      </div>
      <span>
        {extensionType === extensionFunctionType && (
          <FormattedMessage
            id="containers.settings.extensions.createExtension.extensionType.function.description"
            values={{ link: link(FUNCTIONS_LINK) }}
          />
        )}
        {extensionType === extensionWebhookType && (
          <FormattedMessage
            id="containers.settings.extensions.createExtension.extensionType.webhook.description"
            values={{ link: link(WEBHOOKS_LINK) }}
          />
        )}
      </span>
    </Box>
  );
};
